import { useLayoutEffect } from "react";

import { useAuth } from "react-oidc-context";
import type { AxiosInstance } from "axios";
import { getUser } from "@synthesis/shared-auth";
import { axiosInstance } from "../api/axios-instance";

/**
 * Подставляет Bearer в axios, пока пользователь аутентифицирован.
 * Используйте внутри {@link KeycloakOidcProvider} рядом с маршрутизатором, если не используете KeycloakAuth с ProtectedApp.
 */
export const useAuthAxiosInterceptors = () => {
  const auth = useAuth();

  useLayoutEffect(() => {
    if (!auth.isAuthenticated) {
      return;
    }

    const attachBearer = (instance: AxiosInstance) =>
      instance.interceptors.request.use((config) => {
        const user = getUser();

        if (user?.access_token) {
          config.headers.Authorization = "Bearer " + user.access_token;
        }

        return config;
      });

    const mainId = attachBearer(axiosInstance);

    return () => {
      axiosInstance.interceptors.request.eject(mainId);
    };
  }, [auth.isAuthenticated]);

  return null;
};
